import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import * as yup from "yup";
export const AddOrganizationFormInitialValues = {
    name: "",
    domain: "",
};
export const AddOrganizationFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        name: yup
            .string()
            .min(5, intl.formatMessage(messages.organizationNameLength))
            .required(intl.formatMessage(messages.organizationNameRequired)),
        domain: yup
            .string()
            .matches(/\./g, intl.formatMessage(messages.organizationDomainInvalid))
            .required(intl.formatMessage(messages.organizationDomainRequired)),
    });
};
export const AddOrganizationFormFields = () => {
    const intl = useIntl();
    return {
        nameDetails: [
            {
                id: "name",
                label: intl.formatMessage(messages.organizationName),
                placeholder: intl.formatMessage(messages.organizationName),
                required: true,
                columns: 12,
            },
        ],
        domainDetails: [
            {
                id: "domain",
                label: intl.formatMessage(messages.organizationDomain),
                placeholder: intl.formatMessage(messages.organizationDomain),
                required: true,
                columns: 12,
            },
        ],
    };
};
